import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturesSection from './components/FeaturesSection';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'jm漫画',
    url: 'https://jmcomic.com',
    description: 'jm漫画是深受用户喜爱的在线漫画阅读平台，提供海量正版漫画资源，涵盖热血、恋爱、悬疑、奇幻等多种类型。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://jmcomic.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEO
        title="jm漫画 - 正版在线漫画平台官方入口 | 海量漫画免费在线阅读"
        description="jm漫画是深受用户喜爱的在线漫画阅读平台，提供海量正版漫画资源，涵盖热血、恋爱、悬疑、奇幻等多种类型。支持手机、平板、电脑多端畅读，每日更新最新章节，注册即可免费阅读精选内容。"
        keywords="jm漫画,jm漫画官网入口,jm漫画在线阅读,jm漫画最新章节,jm漫画免费看,jm漫画app下载,jm漫画热门推荐"
        canonicalUrl="https://jmcomic.com"
        ogType="website"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryGrid />
        <FeaturesSection />
        <LatestUpdates />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}